import {
    addItemToCollection,
    deleteItemFromCollection,
} from "directus/src/operations";

export async function removeDeliverable(id) {
    try {
        const response = await deleteItemFromCollection("deliverables", id);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function createDeliverable({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "name",
                "url",
                "case_study.id",
            ],
        };
        const data = await addItemToCollection("deliverables", item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}